import React, { useState } from "react";
import {
    Box,
    Grid,
    FormHelperText,
    makeStyles,
    useTheme,
    Typography,
    InputLabel,
    Select,
    IconButton,
    useMediaQuery,
} from '@material-ui/core';
import { Add, Delete } from '@material-ui/icons/';

import { useCalculator } from '../../state/calculatorState';
import {
    StyledTextField,
    StyledFormControl,
    CustomFormControlLabel,
    CustomSwitch,
    PrimaryStaticTextField,
    StaticTextField,
} from '../../components/common/CustomComponents'

import { IntegerFormat, PriceFormat, PriceIntegerFormat, PercentFormat } from '../common/customFormatters';
import { getBracket } from '../../core/Calculator'

import {
    ZERO_VALUE,
} from '../../constants';
import { formatMoney, precision, precisionDP, parseInputValue } from "../../utils/utils";

const SCHOOL_AGE = 6;

const TotalSchedule = [
    // { label: "Day", description: "Daily", data: 10 },
    { label: "Week", title: "Weekly Total", weeks: 1 },
    { label: "Fortnight", title: "Fortnightly Total", weeks: 2 },
    { label: "Month", title: "Monthly Total", weeks: 52 / 12 },
    { label: "Acedemic year (40 weeks)", title: "Total per Acedemic year", weeks: 40 },
    { label: "Working Year (48 weeks)", title: "Total per Working year", weeks: 48 },
    { label: "Full Year (52 weeks)", title: "Annual Total", weeks: 52 },
]

const ChildCareSchedule = [
    // { label: "Day", description: "Daily", data: 10 },
    { label: "Week", description: "Weekly", data: 2 },
    { label: "Fortnight", description: "Fortnightly", data: 1 },
]
/*
const ChildCareType = [
    { label: "Center Based Day Care", note: "Long day care and occasional care", hourlyCap: 12.74 },
    { label: "Family Day Care", note: "Registered educator providing care from their own home", hourlyCap: 11.80 },
    { label: "After School Care", note: "Outside school hours care - before, after and vacation care", hourlyCap: 11.15 },
    { label: "In Home Care*", hourlyCap: 34.64, familyCap: 34.64, note: "The In Home Care (IHC) is capped at 3200 places and is targeted at specific families with non-standard hours, geographic isolation or other complex needs" },
]
*/
const ChildCareType = [
    { label: "Center Based Day Care", note: "Long day care and occasional care", hourlyCap: [13.7263, 12.02] },
    { label: "Family Day Care", note: "Registered educator providing care from their own home", hourlyCap: [12.72, 12.72] },
    { label: "After School Care", note: "Outside school hours care - before, after and vacation care", hourlyCap: [13.73, 12.02] },
    { label: "In Home Care*", hourlyCap: [37.34, 37.34], familyCap: 37.34, note: "The In Home Care (IHC) is capped at 3200 places and is targeted at specific families with non-standard hours, geographic isolation or other complex needs" },
]

const ActivityLevels = [
    { label: "8 hours or less", hours: 24, incomeCap: 72466 }, //66958
    { label: "8 to 16 hours", hours: 36, incomeCap: 0 },
    { label: "16 to 48 hours", hours: 72, incomeCap: 0 },
    { label: "Over 48 hours", hours: 100, incomeCap: 0 },
    // {label:"Volunteer or seeking work",  hours:36, incomeCap:0, note:"You can access upt to 36 hours of subsidised child care if you're a volunteer or actively looking for work. You must spend a minimum of 8 hours each fortnight doing this activity"},
    // {label:"Carer Allowance",  hours:72, incomeCap:0},
    // {label:"Mutual Obligation Requirements",  hours:36, incomeCap:0, note: "Avaliable to carere recieving JobSeeker Payment, Parenting Payment or Special Benefit"},
    // {label:"Exemption",  hours:100, incomeCap:0, note: "You may be expempt from the activity level test if you are either: A grandparent, have a disibility or a carer of a person with a disability or medical condition, in prison, or in psychiatric confinement. Other exceptional circumstances may exemot you from the activity test."},
    // {label:"Preschool",  hours:36, incomeCap:0, note: "If your child is attending an early education orogram such as preschool of kindergarten, and it's the year before the child it to start primary school."},

]

const OtherActivityLevels = [
    { label: "None", hours: 0, incomeCap: 0 },
    { label: "Carer Allowance", hours: 72, incomeCap: 0 },
    { label: "JobSeeker Payment", hours: 36, incomeCap: 0 },
    { label: "Parenting Payment", hours: 36, incomeCap: 0 },
    { label: "Special Benefit", hours: 36, incomeCap: 0 },

    { label: "Exemption", hours: 100, incomeCap: 0, note: "You may be expempt from the activity level test if you are either: A grandparent, have a disibility or a carer of a person with a disability or medical condition, in prison, or in psychiatric confinement. Other exceptional circumstances may exemot you from the activity test." },
    // {label:"Preschool",  hours:36, incomeCap:0, note: "If your child is attending an early education orogram such as preschool of kindergarten, and it's the year before the child it to start primary school."},

]

// const SubsidyRates = [
//     { "from": 0, "to": 72466, "type": "fixed", "value": 0.85 },
//     { "from": 72466, "to": 177466, "type": "linear", "start": 0.85, "end": 0.5 },
//     { "from": 177466, "to": 256756, "type": "fixed", "value": 0.5 },
//     { "from": 256756, "to": 346756, "type": "linear", "start": 0.5, "end": 0.2 },
//     { "from": 346756, "to": 356756, "type": "fixed", "value": 0.2 },
//     { "from": 356756, "to": 0, "type": "fixed", "value": 0.0 },
// ]

// interpolated subsidy rates to increase value by 0.3 with a cap of 0.95
// const SubsidyRatesExtra = [
//     { "from": 0, "to": 132481, "type": "fixed", "value": 0.95 },
//     { "from": 132481, "to": 177466, "type": "linear", "start": 0.95, "end": 0.8 },
//     { "from": 177466, "to": 256756, "type": "fixed", "value": 0.8 },
//     { "from": 256756, "to": 346756, "type": "linear", "start": 0.8, "end": 0.5 },
//     { "from": 346756, "to": 356756, "type": "fixed", "value": 0.5 },
//     { "from": 356756, "to": 0, "type": "fixed", "value": 0.0 },
// ]


// 2024
// const SubsidyRates = [
//     { "from": 0, "to": 80000, "type": "fixed", "value": 0.9 },
//     { "from": 80000, "to": 530000, "type": "linear", "start": 0.9, "end": 0.0, round: 5000 },
//     { "from": 530000, "to": 0, "type": "fixed", "value": 0.0 },
// ]
// const SubsidyRatesExtra = [
//     { "from": 0, "to": 138188, "type": "fixed", "value": 0.95 },
//     { "from": 138188, "to": 183118, "type": "linear", "start": 0.95, "end": 0.8, round: 3000 },
//     { "from": 183118, "to": 262408, "type": "fixed", "value": 0.8 },
//     { "from": 262408, "to": 352408, "type": "linear", "start": 0.8, "end": 0.5, round: 3000 },
//     { "from": 352408, "to": 362408, "type": "fixed", "value": 0.5 },
//     { "from": 362408, "to": 0, "type": "fixed", "value": 0.0 },
// ]

//2025
const SubsidyRates = [
    { "from": 0, "to": 83280, "type": "fixed", "value": 0.9 },
    { "from": 83280, "to": 533280, "type": "linear", "start": 0.9, "end": 0.0, round: 5000 },
    { "from": 533280, "to": 0, "type": "fixed", "value": 0.0 },
]
const SubsidyRatesExtra = [
    { "from": 0, "to": 141321, "type": "fixed", "value": 0.95 },
    { "from": 141321, "to": 186321, "type": "linear", "start": 0.95, "end": 0.8, round: 3000 },
    { "from": 186321, "to": 256611, "type": "fixed", "value": 0.8 },
    { "from": 256611, "to": 355611, "type": "linear", "start": 0.8, "end": 0.5, round: 3000 },
    { "from": 355611, "to": 365611, "type": "fixed", "value": 0.5 },
    { "from": 365611, "to": 0, "type": "fixed", "value": 0.0 },
]

const nominalChild = {
    age: 5,
    type: 0,
    hourSchedule: 0,
    hours: 12,
    hoursPerFortnight: 12,
    rate: 1,
    rateCap: 1,
    cost: 500,
    subsidy: 0,
    subsidyHours: 0,
    subsidyCost: 0,
    subsidyRate: 0,
    higherRate: false,
    costScheduleMultiplier: 1,
    subsidyUtilisation: 1,
}



const useStyles = makeStyles(theme => {
    return {
        image: {
            width: '100%',
            paddingBottom: 20,
        },
        helperText: {
            color: theme.palette.primary.contrastText,
            paddingLeft: 0,
            lineHeight: "1.1",
        },
        helperAlertText:{
            color: theme.palette.secondary.main,
            position:"absolute",
            top:-19,
            right:2,
            paddingLeft: 0,
            letterSpacing: "-0.15px",
            lineHeight: "1.25",
        },
        switchHelperText: {
            opacity: 0.5,
            marginTop: -15,
            paddingLeft: 0,
            marginLeft: 45,
            color: theme.palette.primary.contrastText,
            letterSpacing: "-0.15px",
            lineHeight: "1.25",
        },

    }
});



export const ChildCareSubsidyCalculator = React.memo(() => {
    const theme = useTheme();
    const classes = useStyles();

    const [{ adjustedAnnualTaxableIncome }] = useCalculator();
    const [familyIncome, setFamilyIncome] = useState(adjustedAnnualTaxableIncome);
    const [volunteer, setVolunteer] = useState(false);
    const [activity, setActivity] = useState(3);
    const [otherActivity, setOtherActivity] = useState(0);
    const [children, setChildren] = useState([{ ...nominalChild }]);
    const [taxWithheld, setTaxWithheld] = useState(0);
    const [totalSchedule, setTotalSchedule] = useState(0);

    const [refresh, setRefresh] = useState(false);

    const mobile = useMediaQuery(theme.breakpoints.only('xs'));

    let maxHours = 0;
    let totalCost = 0;
    let totalSubsidy = 0
    // let totalSubsidy2023 = 0
    // let totalSubsidyChange2023 = 0;

    const calculateSubsidy = () => {
        maxHours = ActivityLevels[activity].hours;
        if (otherActivity > 0) {
            maxHours = OtherActivityLevels[otherActivity].hours
        } else {
            // volunteer
            if (volunteer) {
                maxHours = activity > 0 ? 36 : 0
            }
            if (ActivityLevels[activity].incomeCap > 0) {
                if (familyIncome > ActivityLevels[activity].incomeCap) {
                    maxHours = 0
                }
            };
        }

        let hasFamilyCap = 0;

        for (let index = 0; index < children.length; index++) {
            let child = children[index];

            child.hoursPerFortnight = child.hours * ChildCareSchedule[child.hourSchedule].data;
            child.costPerFortnight = child.cost * ChildCareSchedule[child.hourSchedule].data;

            child.rate = child.costPerFortnight / child.hoursPerFortnight


            child.costScheduleMultiplier = 1 / ChildCareSchedule[child.hourSchedule].data;

            // rate cap
            // https://www.servicesaustralia.gov.au/type-child-care-you-use-can-affect-child-care-subsidy?context=41186#hourlyrate
            child.rateCap = Math.min(child.rate, ChildCareType[child.type].hourlyCap)
            if (ChildCareType[child.type].familyCap > 0) {
                // this is a family cap
                hasFamilyCap = ChildCareType[child.type].familyCap
            }

            // hourly rate based on childcare type
            let hourlyRates = ChildCareType[child.type].hourlyCap
            let hourlyRateCap = 0
            // Child age condition
            if (child.age < SCHOOL_AGE) {
                hourlyRateCap = hourlyRates[0]
            } else {
                hourlyRateCap = hourlyRates[1]
            }
            // // 6 or over and at a center based care
            // if (child.age >= 6 && child.type === 0) {
            //     // over school age, use after school rate
            //     hourlyRateCap = ChildCareType[2].hourlyCap

            // } else if (child.age < 6 && child.type === 2) {
            //     // under school age, are use center based
            //     hourlyRateCap = ChildCareType[0].hourlyCap
            // }

            //child.rate = child.rate + 0.005
            child.subsidyHourlyRate = Math.min((child.rate), hourlyRateCap)
            child.subsidyHours = Math.min(child.hoursPerFortnight, maxHours)
            child.subsidyCost = child.subsidyHours * child.subsidyHourlyRate;
            child.subsidyRate = calculateBracket(familyIncome, SubsidyRates)

            // more than one child under 5
            child.subsidy = child.subsidyCost * child.subsidyRate * (1 - (taxWithheld / 100))


            // 2023
            // child.subsidyRate2023 = calculateBracket(familyIncome, SubsidyRates2023)
            // child.subsidy2023 = child.subsidyCost * child.subsidyRate2023 * (1 - (taxWithheld / 100));

        }



        // observe fammly cap
        if (hasFamilyCap > 0) {
            let familyRate = 0
            for (let index = 0; index < children.length; index++) {
                familyRate += children[index].subsidyHourlyRate
            }
            if (familyRate > hasFamilyCap) {
                // reduce everyone by percent difference
                let overspend = (familyRate - hasFamilyCap) / familyRate;
                // recalculate subsidy
                for (let index = 0; index < children.length; index++) {
                    let child = children[index];
                    child.subsidyHourlyRate = child.subsidyHourlyRate - overspend * child.subsidyHourlyRate;
                    child.subsidyCost = child.subsidyHours * child.subsidyHourlyRate;
                    // more than one child under 5
                    child.subsidy = child.subsidyCost * child.subsidyRate * (1 - (taxWithheld / 100))
                }
            }
        }

        
        const higherSubsidyMultipleChildren = children.filter(c => c.age < SCHOOL_AGE).length > 1

        if (higherSubsidyMultipleChildren) {
            // determine the standrd rate child
            let eldest = -1;
            let eldestIndex = -1
            for (let index = 0; index < children.length; index++) {
                const age = children[index].age
                if (age > eldest && age <= 5) {
                    eldest = children[index].age
                    eldestIndex = index;
                }
            }
            // mark as standard or higher
            for (let index = 0; index < children.length; index++) {
                const age = children[index].age

                if (eldestIndex >= 0 && index !== eldestIndex && age <= 5 && children[index].type !== 3) {
                    // apply special rate
                    //children[index].subsidyRate = Math.min(ExtraChildCap, children[index].subsidyRate + ExtraChildBonus);

                    // if the rate is exceesed, use the standard rate (that has already been calculated as the default)
                    // calculate bonus rate
                    let subsidyRate = calculateBracket(familyIncome, SubsidyRatesExtra)
                    if (subsidyRate > 0) {
                        // recalculate subsidy with the new higher rate
                        children[index].subsidyRate = subsidyRate
                        children[index].subsidy = children[index].subsidyCost * subsidyRate * (1 - (taxWithheld / 100));
                        children[index].higherRate = true;

                    } else {
                        children[index].higherRate = false;
                    }
                } else {
                    children[index].higherRate = false;
                }
            }

        }else{
            // remove higherRate property
            for (let index = 0; index < children.length; index++) {
                children[index].higherRate = false;
            }

        }
        for (let index = 0; index < children.length; index++) {
            let child = children[index];
            child.subsidyUtilisation = precision(Math.min(1, child.hoursPerFortnight / maxHours), 2);
        }


        // totals
        totalCost = 0;
        totalSubsidy = 0

        for (let index = 0; index < children.length; index++) {
            totalCost += children[index].costPerFortnight;
            totalSubsidy += children[index].subsidy;
        }

        // convert to weekly
        totalSubsidy *= 0.5;
        totalCost *= 0.5

        // convert to schedule
        totalSubsidy *= TotalSchedule[totalSchedule].weeks
        totalCost *= TotalSchedule[totalSchedule].weeks


        // totals 2023
        // totalSubsidy2023 = 0
        // for (let index = 0; index < children.length; index++) {
        //     totalSubsidy2023 += children[index].subsidy2023;
        // }
        // totalSubsidy2023 *= 0.5
        // totalSubsidy2023 *= TotalSchedule[totalSchedule].weeks

        // totalSubsidyChange2023 = totalSubsidy2023 - totalSubsidy;


    }


    const calculateBracket = (income, brackets) => {
        let subsidy = getBracket(income, brackets);
        let subsidyRate = 0;
        switch (subsidy.type) {
            case "fixed":
                subsidyRate = subsidy.value;
                break;
            case "linearStepped":
                let over = income - subsidy.from;
                let overStep = Math.ceil(over / subsidy.allocation)
                // subsidyRate = Number(precision(subsidy.start - (overStep * subsidy.nearest), 5))
                subsidyRate = subsidy.start - (overStep * subsidy.nearest)
                break;
            case "linear":
                let slope = (subsidy.end - subsidy.start) / (subsidy.to - subsidy.from);
                let offset = subsidy.start - (slope * subsidy.from)

                let roundedIncome = income;// subsidy.round * Math.floor(income/subsidy.round)
                //subsidyRate = Number(precision(slope * income + offset, 7))
                subsidyRate = (slope * roundedIncome) + offset

                // rounding
                //subsidyRate = Math.round(subsidyRate*100)/100;

                break;
            default:
                subsidyRate = 0;
                break;
        }
        return subsidyRate
    }


    // calculate subsidy
    calculateSubsidy(children);

    const handleChangeFamilyIncome = () => event => {
        if (document.activeElement.className !== event.target.className) return;
        let newValue = Number(parseInputValue(event.target.value));
        newValue = newValue.toLocaleString('fullwide', { useGrouping: false })
        if (familyIncome === ZERO_VALUE) {
            newValue = (newValue - ZERO_VALUE) / 10;
        }
        //const value = newValue > 0 ? newValue : ZERO_VALUE;
        setFamilyIncome(newValue);
    }


    const modifyChildrenCount = (count) => {
        if (children.length > count) {
            // remove children
            setChildren(children.splice(0, count))
        } else {
            // add children
            while (children.length < count) {
                children.push({ ...nominalChild })
            }
            setChildren(children)
        }

        setRefresh(!refresh)
    }

    const modifyChildren = (index, data) => {
        children[index] = { ...children[index], ...data }
        setChildren(children)
        setRefresh(!refresh)
    }

    const deleteChild = (index) => {
        setChildren(children.splice(index, 1))
        setChildren(children)
        setRefresh(!refresh)
    }




    const eligibleChildrenComponent = () => {
        return (
            <Grid item xs={12} md={6}>
                <Typography variant="h3" style={{ fontSize: 16, color: theme.palette.primary.main }}>{`Number of Children`}</Typography>
                <Typography variant="body1">If you have more than one child aged 5 or younger in care, you may get a higher Child Care Subsidy. This may apply for one or more of your children.</Typography>
                <Grid container spacing={2}>
                    <Grid item xs={8} md={8}>
                        <StyledTextField
                            label={"Eligible Children"}
                            fullWidth
                            disabled={maxHours === 0}
                            value={children.length > 0 ? children.length :null}
                            defaultValue={0}
                            variant="filled"
                            type="text"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                inputComponent: IntegerFormat,
                                inputMode: 'numeric',
                                inputProps: {
                                    inputMode: 'numeric',
                                },
                            }}
                            onChange={(event) => modifyChildrenCount(Number(event.target.value))}
                            id="EligibleChildren"
                        />
                    </Grid>
                    <Grid item xs={4} md={4}>
                        <Box display="flex" flexDirection="column" alignItems="center" style={{}}>
                            <IconButton
                                disableRipple
                                disableTouchRipple
                                aria-label="more children"
                                onClick={(event) => modifyChildrenCount(Number(children.length + 1))}
                            >
                                <Box display="flex" flexDirection="column" alignItems="center">
                                    <Add />
                                </Box>
                            </IconButton>
                            <Typography variant="body2">Add Child</Typography>
                        </Box>

                    </Grid>
                </Grid>
            </Grid>
        )
    }


    const taxWithheldComponent = () => {
        return (
            <Grid item xs={12} md={6}>
                <Typography variant="h3" style={{ fontSize: 16, color: theme.palette.primary.main }}>{`Tax Withheld`}</Typography>
                <Typography variant="body1">Typically 5% is withheld from your subsidy. This is to help reduce the likelihood of you getting an over payment. You're able to vary this amount to suit your circumstances.</Typography>
                <StyledTextField
                    label={"Tax Withheld"}
                    fullWidth
                    disabled={maxHours === 0}
                    value={taxWithheld > 0 ? taxWithheld :null}
                    defaultValue={0}
                    variant="filled"
                    type="text"
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                        inputComponent: PercentFormat,
                        inputMode: 'numeric',
                        inputProps: {
                            inputMode: 'numeric',
                        },
                    }}
                    onChange={(event) => setTaxWithheld(Number(event.target.value))}
                    id="Tax Withheld"
                />
            </Grid>
        )
    }

    const dividerComponent = () => {
        return (
            <Grid item xs={12} style={{ marginBottom: -10, marginTop: 20 }}>
                <Box style={{ width: '100%', height: 1, backgroundColor: theme.palette.background.overlay }}></Box>
            </Grid>
        )
    }



    return (
        <Box style={{ padding: '0px 20px' }}>
            <Grid container spacing={2} alignItems="flex-start">

                <Grid item xs={12}>
                    <Typography variant="h3" style={{ fontSize: 16, color: theme.palette.primary.main }}>{`Eligibility Criteria`}</Typography>
                    <ul>
                        <li>
                            <Typography variant="body1">You care for your child al least 2 nights per fortnight, or 14% care</Typography>
                        </li>
                        <li>
                            <Typography variant="body1">Liable for fees from an approved child care service</Typography>
                        </li>
                        <li>
                            <Typography variant="body1">Living in Australia and be either; a citizen, a permanent resident, have a special visa, sponsored student or in hardship</Typography>
                        </li>
                        <li>
                            <Typography variant="body1">Child must meet immunisation requirements</Typography>
                        </li>
                        <li>
                            <Typography variant="body1">Child not attending secondary school (unless exempt)</Typography>
                        </li>
                    </ul>

                </Grid>
                <Grid item xs={12} md={6} >
                    <Typography variant="h3" style={{ fontSize: 16, color: theme.palette.primary.main }}>{`Income Criteria`}</Typography>
                    <Typography variant="body1">You need to provide an estimate of how much you and your partner make in the current financial year. In addition to regular salary you also need to include other kinds of income such as additional bonuses, payouts, or investment income. </Typography>
                </Grid>
                <Grid item xs={12} md={6} >
                    <Typography variant="h3" style={{ fontSize: 16, color: theme.palette.primary.main }}>{`Activity Criteria`}</Typography>
                    <Typography variant="body1">Select how many hours you work per fortnight, or select a special activity type. If you have a partner, choose the carer who has the lower activity level. You can include reasonable time taken to travel between your child care service and the location of your recognised activity. This could include your place of work, training, study or other activity.</Typography>
                </Grid>

                <Grid item xs={12} md={6}>

                    <StyledTextField
                        label={"Family Income"}
                        fullWidth
                        value={familyIncome > 0 ? familyIncome : null}
                        defaultValue={0}
                        variant="filled"
                        type="text"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            'aria-label': 'Family Income',
                            inputComponent: PriceIntegerFormat,
                            inputMode: 'numeric',
                            inputProps: {
                                inputMode: 'numeric',
                            },
                        }}
                        onChange={handleChangeFamilyIncome()}
                        id="familyIncome"
                    />
                    <FormHelperText className={classes.helperText}>{`Combined annual household income`} </FormHelperText>

                    {/* <Typography variant="h3" style={{ fontSize: 16, color: theme.palette.primary.main }}>{`Number of hours per child ${maxHours}`}</Typography> */}

                </Grid>
                <Grid item xs={12} md={6} >
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <StyledFormControl variant="filled" fullWidth >
                                <InputLabel htmlFor="activityTest">Work each fortnight</InputLabel>
                                <Select
                                    native
                                    disabled={otherActivity > 0}
                                    variant="filled"
                                    id="activityTest"
                                    aria-label="activity Test"
                                    onChange={(event) => setActivity(event.target.value)}
                                    value={activity}
                                >
                                    {ActivityLevels.map((option, index) => (
                                        <option
                                            key={`${option.label}-${index}`}
                                            value={index}
                                        >
                                            {option.label}
                                        </option>
                                    ))}
                                </Select>
                            </StyledFormControl>


                        </Grid>
                        <Grid item xs={6}>
                            <StyledFormControl variant="filled" fullWidth >
                                <InputLabel htmlFor="otherActivityTest">Other Activity Criteria</InputLabel>
                                <Select
                                    native
                                    variant="filled"
                                    id="otherActivityTest"
                                    aria-label="Other activity Test"
                                    onChange={(event) => setOtherActivity(event.target.value)}
                                    value={otherActivity}
                                >
                                    {OtherActivityLevels.map((option, index) => (
                                        <option
                                            key={`${option.label}-${index}`}
                                            value={index}
                                        >
                                            {option.label}
                                        </option>
                                    ))}
                                </Select>
                            </StyledFormControl>

                        </Grid>
                        <Grid item xs={12} style={{ marginTop: -12 }}>
                            <FormHelperText className={classes.helperText}>{`Maximum subsidy of ${maxHours} hours per child`} </FormHelperText>
                            <CustomFormControlLabel control={
                                <CustomSwitch
                                    id="VolunteerCCSSwitch"
                                    disabled={otherActivity > 0}
                                    checked={volunteer}
                                    onChange={(event) => {
                                        setVolunteer(event.target.checked)
                                    }}
                                    color="primary"
                                />
                            }
                                label='Volunteer or looking for work'
                            />
                        </Grid>
                    </Grid>
                </Grid>

                {maxHours > 0 && mobile && (taxWithheldComponent())}
                {maxHours > 0 && mobile && (eligibleChildrenComponent())}


                {maxHours > 0 && !mobile && (eligibleChildrenComponent())}
                {maxHours > 0 && !mobile && (taxWithheldComponent())}


                {maxHours === 0 && (
                    <Grid item xs={12}>
                        <Typography variant="h3" style={{ fontSize: 16, color: theme.palette.primary.main, paddingBottom: 20 }}>{`You are not entitled to recieve the Child Care Subsidy`}</Typography>
                    </Grid>
                )}

            </Grid>

            {maxHours > 0 && children.map((child, index) => {
                return (

                    <Grid container key={`Child:${index}`} spacing={2}>
                        {dividerComponent()}
                        <Grid item xs={6} style={{ marginBottom: -10, marginTop: 20 }}>
                            <Typography variant="h3" style={{ fontSize: 16, color: theme.palette.primary.main }}>Child {index + 1}</Typography>
                        </Grid>
                        <Grid item xs={6} style={{ margin: 0, padding: 0, marginBottom: -20, marginTop: 20 }}>
                            <Box display="flex" flexDirection="row" alignItems="center" justifyContent="flex-end">
                                <Typography variant="body2">Remove Child</Typography>
                                <IconButton
                                    disableRipple
                                    disableTouchRipple
                                    aria-label="more children"
                                    onClick={() => deleteChild(index)}
                                >
                                    <Box display="flex" flexDirection="column" alignItems="center" style={{ opacity: 1.0, transform: 'scale(0.75)' }}>
                                        <Delete />
                                    </Box>

                                </IconButton>

                            </Box>
                        </Grid>

                        <Grid item xs={2} md={1} >
                            <StyledFormControl variant="filled" fullWidth >
                                <StyledTextField
                                    label={"Age"}
                                    fullWidth
                                    disabled={maxHours === 0}
                                    value={child.age > 0 ? child.age : null}
                                    defaultValue={0}
                                    variant="filled"
                                    type="text"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        'aria-label': 'Age',
                                        inputComponent: IntegerFormat,
                                        inputMode: 'numeric',
                                        inputProps: {
                                            inputMode: 'numeric',
                                        },
                                    }}
                                    onChange={(event) => modifyChildren(index, { age: Number(event.target.value) })}
                                    id="Childcare age"
                                />
                            </StyledFormControl>

                        </Grid>

                        <Grid item xs={10} md={5} >
                            <StyledFormControl variant="filled" fullWidth >
                                <InputLabel htmlFor="ChildCareType">Child Care Type</InputLabel>
                                <Select
                                    native
                                    variant="filled"
                                    id="ChildCareType"
                                    aria-label="Childcare type"
                                    onChange={(event) => modifyChildren(index, { type: Number(event.target.value) })}
                                    value={child.type}
                                >
                                    {ChildCareType.map((option, index) => (
                                        <option
                                            key={`${option.label}-${index}`}
                                            value={index}
                                        >
                                            {option.label}
                                        </option>
                                    ))}
                                </Select>
                            </StyledFormControl>
                            <FormHelperText className={classes.helperText}>{ChildCareType[child.type].note} </FormHelperText>
                        </Grid>

                        <Grid item xs={4} md={2} >
                            <StyledFormControl variant="filled" fullWidth >
                                <InputLabel htmlFor="ChildCare Billing Schedule">Billing cycle</InputLabel>
                                <Select
                                    native
                                    variant="filled"
                                    id="ChildCare Billing Schedule"
                                    aria-label="ChildCare Billing Schedule"
                                    onChange={(event) => modifyChildren(index, { hourSchedule: Number(event.target.value) })}
                                    value={child.hourSchedule}
                                >
                                    {ChildCareSchedule.map((option, index) => (
                                        <option
                                            key={`${option.label}-${index}`}
                                            value={index}
                                        >
                                            {option.label}
                                        </option>
                                    ))}
                                </Select>
                            </StyledFormControl>
                        </Grid>

                        <Grid item xs={4} md={2} >
                            <StyledFormControl variant="filled" fullWidth >
                                <StyledTextField
                                    label={`${ChildCareSchedule[child.hourSchedule].description} Hours`}
                                    // label={`Hours per ${ChildCareSchedule[child.hourSchedule].label}`}
                                    fullWidth
                                    disabled={maxHours === 0}
                                    value={child.hours > 0 ? child.hours :null}
                                    defaultValue={0}
                                    variant="filled"
                                    type="text"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        'aria-label': 'childcare hours',
                                        inputComponent: IntegerFormat,
                                        inputMode: 'numeric',
                                        inputProps: {
                                            inputMode: 'numeric',
                                        },
                                    }}
                                    onChange={(event) => modifyChildren(index, { hours: Number(event.target.value) })}
                                    id="childcare hours"
                                />
                            </StyledFormControl>
                            {/* <FormHelperText className={classes.helperText}>{`${child.hoursPerFortnight} hrs per fortnight`} </FormHelperText> */}
                        </Grid>



                        <Grid item xs={4} md={2} >
                            <StyledFormControl variant="filled" fullWidth >
                                <StyledTextField
                                    label={`${ChildCareSchedule[child.hourSchedule].description} Cost`}
                                    // label={`Cost per ${ChildCareSchedule[child.hourSchedule].label}`}
                                    fullWidth
                                    disabled={maxHours === 0}
                                    value={child.cost > 0 ? child.cost :null}
                                    defaultValue={0}
                                    variant="filled"
                                    type="text"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        'aria-label': 'childcare cost',
                                        inputComponent: PriceFormat,
                                        inputMode: 'numeric',
                                        inputProps: {
                                            inputMode: 'numeric',
                                        },
                                    }}
                                    onChange={(event) => modifyChildren(index, { cost: Number(event.target.value) })}
                                    id="Childcare cost"
                                />

                            </StyledFormControl>
                            {/* <FormHelperText className={classes.helperText}>{`$${formatMoney(ChildCareType[child.type].hourlyCap)} cap`} </FormHelperText> */}
                        </Grid>


                        <Grid item xs={12} md={6} >
                        </Grid>

                        <Grid item xs={4} md={2} >
                            <PrimaryStaticTextField
                                label={`Cost`}
                                fullWidth
                                value={`$${formatMoney(child.costScheduleMultiplier * (child.costPerFortnight - child.subsidy))}`}
                                // defaultValue={0}
                                variant="filled"
                                type="text"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    'aria-label': 'Cost'
                                }}
                                id="Childcare expense"
                            />
                            <FormHelperText className={classes.helperText}>{`After subsidy`} </FormHelperText>
                            {/* <FormHelperText className={classes.helperText}>{`$${formatMoney(child.costScheduleMultiplier * child.cost)} without subsidy`} </FormHelperText> */}
                        </Grid>
                        <Grid item xs={4} md={2} >
                            <Box style={{ position: "relative" }}>
                                <StaticTextField
                                    label={`Subsidy`}
                                    fullWidth
                                    value={`$${formatMoney(child.costScheduleMultiplier * child.subsidy)}`}
                                    // defaultValue={0}
                                    variant="filled"
                                    type="text"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        'aria-label': 'Childcare subsidy'
                                    }}
                                    id="Childcare subsidy"
                                />
                                <FormHelperText className={classes.helperText}>{`${precisionDP(child.subsidyRate * 100, 2)}% subsidy`} </FormHelperText>
                                { child.higherRate &&(
                                    <FormHelperText className={classes.helperAlertText}>{`Higher rate`} </FormHelperText>
                                )}
                                { child.subsidyRate === 0.9 &&(
                                    <FormHelperText className={classes.helperAlertText} style = {{color: theme.palette.secondary.light}}>{`Max standard rate`} </FormHelperText>
                                )}
                                
                            </Box>


                        </Grid>


                        <Grid item xs={4} md={2} >
                            <Box style={{ position: "relative" }}>
                                <StaticTextField
                                    label={"Utilisation"}
                                    fullWidth
                                    value={`${(precisionDP(child.subsidyUtilisation * 100, 2))}%`}
                                    //defaultValue={0}
                                    variant="filled"
                                    type="text"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        'aria-label': 'Cost'
                                    }}
                                    id="Childcare utilisation"
                                />
                                {/* <FormHelperText className={classes.helperText}>{`Max ${maxHours} hrs per fortnight`} </FormHelperText> */}
                                <FormHelperText className={classes.helperText}>{`${child.subsidyHours * child.costScheduleMultiplier}/${maxHours * child.costScheduleMultiplier} hours`} </FormHelperText>
                                <Box style={{ position: "absolute", top: 52, left: 0, height: 4, width: `100%`, backgroundColor: theme.palette.primary.dark }}></Box>
                                <Box style={{ position: "absolute", top: 52, left: 0, height: 4, width: `${(child.subsidyUtilisation * 100)}%`, backgroundColor: theme.palette.primary.light }}></Box>
                            </Box>
                        </Grid>
                    </Grid>
                )
            })



            }

            {maxHours > 0 && children.length > 0 && (
                <Grid container spacing={2}>
                    {dividerComponent()}
                    <Grid item xs={12} style={{ marginBottom: -10, marginTop: 20 }}>
                        <Typography variant="h3" style={{ fontSize: 16, color: theme.palette.primary.main }}>{TotalSchedule[totalSchedule].title}</Typography>
                    </Grid>

                    <Grid item xs={6} md={3}  >
                        <PrimaryStaticTextField
                            label={"Childcare Cost"}
                            fullWidth
                            value={`$${formatMoney(totalCost - totalSubsidy)}`}
                            //defaultValue={0}
                            variant="filled"
                            type="text"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                'aria-label': 'Childcare cost'
                            }}
                            id="Childcare summary cost"
                        />
                        {taxWithheld > 0 && (
                            <FormHelperText className={classes.helperText}>{`Excluding ${taxWithheld}% witholding`} </FormHelperText>
                        )}
                    </Grid>

                    <Grid item xs={6} md={3} >
                        <StyledFormControl variant="filled" fullWidth >
                            <InputLabel htmlFor="ChildCareSchedule">Total per</InputLabel>
                            <Select
                                native
                                variant="filled"
                                id="ChildCareSchedule"
                                aria-label="ChildCare Schedule"
                                onChange={(event) => setTotalSchedule(Number(event.target.value))}
                                value={totalSchedule}
                            >
                                {TotalSchedule.map((option, index) => (
                                    <option
                                        key={`${option.label}-${index}`}
                                        value={index}
                                    >
                                        {option.label}
                                    </option>
                                ))}
                            </Select>
                        </StyledFormControl>
                    </Grid>

                    <Grid item xs={6} md={3}  >
                        <StaticTextField
                            label={"Total Subsidy"}
                            fullWidth
                            value={`$${formatMoney(totalSubsidy)}`}
                            //defaultValue={0}
                            variant="filled"
                            type="text"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                'aria-label': 'Childcare total subsidy'
                            }}
                            id="Childcare total subsidy"
                        />
                        {taxWithheld > 0 && (
                            <FormHelperText className={classes.helperText}>{`$${formatMoney(totalSubsidy + totalSubsidy * (taxWithheld / 100))} including withholding amount`} </FormHelperText>
                        )}
                    </Grid>

                    <Grid item xs={6} md={3}  >
                        <StaticTextField
                            label={"Cost without Subsidy"}
                            fullWidth
                            value={`$${formatMoney(totalCost)}`}
                            //defaultValue={0}
                            variant="filled"
                            type="text"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                'aria-label': 'Childcare total without subsidy'
                            }}
                            id="Childcare total without subsidy"
                        />
                        <FormHelperText className={classes.helperText}>{`${precisionDP((totalSubsidy / totalCost) * 100, 1)}% saving`} </FormHelperText>
                    </Grid>



                    {/* 
                    <Grid item xs={12} style={{ marginBottom: -5, marginTop: -5 }}>
                        <Typography variant="h3" style={{ fontSize: 16, color: theme.palette.primary.main }}>New 2023 Rates</Typography>
                        <Typography variant="body1">Changes to the Child Care Subsidy outlined in the October Budget are planned to start in July 2023. This is an estimate of how the changes will reduce your childcare costs in 2023.</Typography>
                    </Grid>

                    <Grid item xs={6} md={3}  >
                    <PrimaryStaticTextField
                            label={"Childcare Cost 2023"}
                            fullWidth
                            value={`$${formatMoney(totalCost - totalSubsidy2023)}`}
                            //defaultValue={0}
                            variant="filled"
                            type="text"
                            InputLabelProps={{ shrink: true }}
                            id="Childcare total cost 2023"
                        />
                    </Grid>

                    <Grid item xs={6} md={3}  >
                        <Box display="flex" alignItems='center' justifyContent='flex-start' style={{height:'100%'}}>
                    <Typography variant="body1">
                        {`$${formatMoney(totalSubsidyChange2023)} cheaper per ${TotalSchedule[totalSchedule].label}`}
                    </Typography>
                    </Box>


                    </Grid>

                    <Grid item xs={6} md={3}  >
                    <PrimaryStaticTextField
                            label={"Total Subsidy 2023"}
                            fullWidth
                            value={`$${formatMoney(totalSubsidy2023)}`}
                            //defaultValue={0}
                            variant="filled"
                            type="text"
                            InputLabelProps={{ shrink: true }}
                            id="Childcare total subsidy 2023"
                        />
                    </Grid>

                    <Grid item xs={6} md={3}  >
                    <Box display="flex" alignItems='center' justifyContent='flex-start' style={{height:'100%'}}>
                    <Typography variant="body1">
                        {`${precisionDP((totalSubsidyChange2023/totalSubsidy)*100, 1)}% increase`}
                    </Typography>
                    </Box>
                    </Grid>
                    <Grid item xs={12} >
                    </Grid> */}


                </Grid>



            )}
        </Box >
    );
}
)

export default ChildCareSubsidyCalculator